// extracted by mini-css-extract-plugin
export default {"contentContainer":"ForgotPassword_contentContainer__dbqQK"};